import {Navigate, useParams} from "react-router-dom";

function SettingsRedirect() {
  const { accountId } = useParams();

  return (<Navigate to={ `/${accountId}/subscription` } replace={true} />);
}

export default SettingsRedirect;
